(function () {
  'use strict';

  const ROOT_SELECTOR = '[data-cart-promo-progress]';
  const TITLE_SELECTOR = '[data-cart-promo-title]';
  const SHIPPING_SELECTOR = '[data-cart-free-shipping-message]';

  const CART_EVENTS = [
    'cart:updated',
    'cart:change',
    'cart:refresh',
    'ajaxCart:updated',
    'cart-drawer:updated',
    'cartUpdate'
  ];

  const PROMO_TEXT_ATTRIBUTES = [
    'data-excluded-product-ids',
    'data-excluded-product-titles',
    'data-text-1-product',
    'data-text-2-products',
    'data-text-completed',
    'data-gift-threshold',
    'data-free-shipping-text',
    'data-free-shipping-completed-text',
    'data-free-shipping-threshold'
  ];

  let updateTimer = null;
  let isUpdating = false;
  let pendingUpdate = false;

  function getDataAttr(root, attrName, fallback) {
    const value = root.getAttribute(attrName);

    if (value === null || value === '') {
      return fallback;
    }

    return value;
  }

  function getCartUrl() {
    const root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    return root + 'cart.js';
  }

  function formatMoney(cents) {
    const amount = Math.max(0, Number(cents || 0)) / 100;
    return '₪' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function getExcludedProductIds(root) {
    return String(getDataAttr(root, 'data-excluded-product-ids', ''))
      .split('|')
      .map(function (id) {
        return id.trim();
      })
      .filter(Boolean);
  }

  function getExcludedProductTitles(root) {
    return String(getDataAttr(root, 'data-excluded-product-titles', 'מוצר מתנה'))
      .split('|')
      .map(function (title) {
        return title.trim();
      })
      .filter(Boolean);
  }

  function isGiftProductLineItem(item, excludedTitles) {
    if (!item) {
      return false;
    }

    const title = String(item.product_title || item.title || '').trim();

    return excludedTitles.indexOf(title) !== -1;
  }

  function isPromoExcludedLineItem(item) {
    if (!item) {
      return false;
    }

    const properties = item.properties || {};

    if (typeof properties !== 'object') {
      return false;
    }

    return (
      String(properties._promo_excluded || '').toLowerCase() === 'true' ||
      String(properties._bundle || '').toLowerCase() === 'true' ||
      String(properties._kit || '').toLowerCase() === 'true'
    );
  }

  function getEligibleItemCount(root, cart) {
    const excludedProductIds = getExcludedProductIds(root);
    const excludedProductTitles = getExcludedProductTitles(root);

    if (!cart || !Array.isArray(cart.items)) {
      return Number(getDataAttr(root, 'data-cart-items-count', 0));
    }

    return cart.items.reduce(function (total, item) {
      const productId = String(item.product_id || '');

      if (excludedProductIds.indexOf(productId) !== -1) {
        return total;
      }

      if (isGiftProductLineItem(item, excludedProductTitles)) {
        return total;
      }

      if (isPromoExcludedLineItem(item)) {
        return total;
      }

      return total + Number(item.quantity || 0);
    }, 0);
  }

  function getPromoState(root, itemCount, totalPrice) {
    const threshold = Number(getDataAttr(root, 'data-gift-threshold', 39900));
    // The gift is earned strictly ABOVE the configured threshold, in cents.
    const giftUnlocked = totalPrice > threshold;
    const giftLeft = Math.max(0, threshold + 1 - totalPrice);
    let title = getDataAttr(root, 'data-text-1-product', 'הוסיפי עוד מוצר וקבלי 25% הנחה');

    if (itemCount >= 2) {
      title = giftUnlocked
        ? getDataAttr(root, 'data-text-completed', 'קיבלת 25% הנחה וגם מתנה שווה מאיתנו!')
        : getDataAttr(root, 'data-text-2-products', 'הוסיפי עוד [amount] וקבלי מתנה מקולקציית Milk & Chocolate');
    }

    return {
      progress: itemCount >= 2 ? (giftUnlocked ? 100 : 50) : (itemCount >= 1 ? 25 : 0),
      title: title.split('[amount]').join(formatMoney(giftLeft)),
      active20: itemCount >= 1,
      active25: itemCount >= 2,
      activeGift: giftUnlocked
    };
  }

  function setStepState(root, selector, isActive) {
    const step = root.querySelector(selector);

    if (!step) {
      return;
    }

    step.classList.toggle('is-active', isActive);
  }

  function updateShippingText(root, totalPrice) {
    const shipping = root.querySelector(SHIPPING_SELECTOR);

    if (!shipping) {
      return;
    }

    const shippingText = shipping.querySelector('.cart-promo-progress__shipping-text');

    if (!shippingText) {
      return;
    }

    const threshold = Number(getDataAttr(root, 'data-free-shipping-threshold', 34900));
    const shippingLeft = threshold - Number(totalPrice || 0);

    if (shippingLeft > 0) {
      const template = getDataAttr(
        root,
        'data-free-shipping-text',
        'חסרים לך [amount] למשלוח חינם בישראל'
      );

      shippingText.replaceChildren();
      template.split('[amount]').forEach(function (part, index) {
        if (index > 0) {
          const amount = document.createElement('span');
          amount.className = 'cart-promo-progress__shipping-amount';
          amount.textContent = formatMoney(shippingLeft);
          shippingText.appendChild(amount);
        }
        shippingText.appendChild(document.createTextNode(part));
      });

      return;
    }

    shippingText.textContent = getDataAttr(
      root,
      'data-free-shipping-completed-text',
      'קיבלת משלוח חינם בישראל'
    );
  }

  function updateRoot(root, cart) {
    if (!root) {
      return;
    }

    cart = cart || {};

    const itemCount = getEligibleItemCount(root, cart);
    const totalPrice =
      typeof cart.total_price !== 'undefined'
        ? Number(cart.total_price || 0)
        : Number(getDataAttr(root, 'data-cart-total-price', 0));

    root.setAttribute('data-cart-items-count', String(itemCount));
    root.setAttribute('data-cart-total-price', String(totalPrice));

    if (itemCount <= 0) {
      root.hidden = true;
    } else {
      root.hidden = false;
    }

    const state = getPromoState(root, itemCount, totalPrice);

    const title = root.querySelector(TITLE_SELECTOR);
    const bar = root.querySelector('.cart-promo-progress__bar');
    const fill = root.querySelector('.cart-promo-progress__fill');

    if (title) {
      title.textContent = state.title;
    }

    if (bar) {
      bar.style.setProperty('--cart-promo-progress', state.progress + '%');
    }

    if (fill) {
      fill.style.width = state.progress + '%';
    }

    setStepState(root, '.cart-promo-progress__step--20', state.active20);
    setStepState(root, '.cart-promo-progress__step--25', state.active25);
    setStepState(root, '.cart-promo-progress__step--gift', state.activeGift);

    updateShippingText(root, totalPrice);
  }

  async function fetchCart() {
    const response = await fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Cart request failed: ' + response.status);
    }

    return response.json();
  }

  async function fetchAndUpdateCartPromoProgress() {
    const roots = document.querySelectorAll(ROOT_SELECTOR);

    if (!roots.length) {
      return;
    }

    if (isUpdating) {
      pendingUpdate = true;
      return;
    }

    isUpdating = true;
    pendingUpdate = false;

    try {
      const cart = await fetchCart();

      document.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
        updateRoot(root, cart);
      });
    } catch (error) {
      console.warn('Cart promo progress update failed:', error);
    } finally {
      isUpdating = false;

      if (pendingUpdate) {
        pendingUpdate = false;
        scheduleUpdate(100);
      }
    }
  }

  function scheduleUpdate(delay) {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      fetchAndUpdateCartPromoProgress();
    }, typeof delay === 'number' ? delay : 300);
  }

  function isCartMutationUrl(url) {
    if (!url) {
      return false;
    }

    url = String(url);

    return (
      url.indexOf('/cart/add') !== -1 ||
      url.indexOf('/cart/change') !== -1 ||
      url.indexOf('/cart/update') !== -1 ||
      url.indexOf('/cart/clear') !== -1
    );
  }

  function getRequestUrl(input) {
    if (!input) {
      return '';
    }

    if (typeof input === 'string') {
      return input;
    }

    if (input.url) {
      return input.url;
    }

    return String(input);
  }

  function bindCartEvents() {
    CART_EVENTS.forEach(function (eventName) {
      document.addEventListener(eventName, function () {
        scheduleUpdate(100);
      });
    });

    document.addEventListener('click', function (event) {
      if (
        event.target.closest('[button-plus]') ||
        event.target.closest('[button-minus]') ||
        event.target.closest('cart-remove-button') ||
        event.target.closest('[data-add-to-cart]') ||
        event.target.closest('[name="add"]')
      ) {
        scheduleUpdate(700);
        scheduleUpdate(1400);
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target.matches('.ajax-quantity, .quantity-input, [name="updates[]"]')) {
        scheduleUpdate(500);
        scheduleUpdate(1200);
      }
    });
  }

  function bindDomUpdates() {
    if (!window.MutationObserver || !document.body) {
      return;
    }

    const observer = new MutationObserver(function (mutations) {
      let shouldFetchCart = false;

      mutations.forEach(function (mutation) {
        if (shouldFetchCart) {
          return;
        }

        if (mutation.type === 'attributes') {
          if (
            mutation.target.matches &&
            mutation.target.matches(ROOT_SELECTOR) &&
            PROMO_TEXT_ATTRIBUTES.indexOf(mutation.attributeName) !== -1
          ) {
            shouldFetchCart = true;
          }

          return;
        }

        if (mutation.type !== 'childList') {
          return;
        }

        Array.from(mutation.addedNodes).forEach(function (node) {
          if (shouldFetchCart || node.nodeType !== Node.ELEMENT_NODE) {
            return;
          }

          if (
            (node.matches && node.matches(ROOT_SELECTOR)) ||
            (node.querySelector && node.querySelector(ROOT_SELECTOR)) ||
            (node.matches && node.matches('[data-cart-drawer-body]')) ||
            (node.querySelector && node.querySelector('[data-cart-drawer-body]')) ||
            (node.matches && node.matches('cart-drawer')) ||
            (node.querySelector && node.querySelector('cart-drawer'))
          ) {
            shouldFetchCart = true;
          }
        });
      });

      if (shouldFetchCart) {
        scheduleUpdate(100);
        scheduleUpdate(700);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: PROMO_TEXT_ATTRIBUTES
    });
  }

  function bindThemeEditorUpdates() {
    document.addEventListener('shopify:section:load', function () {
      scheduleUpdate(100);
    });

    document.addEventListener('shopify:section:select', function () {
      scheduleUpdate(100);
    });

    document.addEventListener('shopify:block:select', function () {
      scheduleUpdate(100);
    });
  }

  function patchFetch() {
    if (!window.fetch || window.__cartPromoFetchPatched) {
      return;
    }

    window.__cartPromoFetchPatched = true;

    const originalFetch = window.fetch;

    window.fetch = function () {
      const requestUrl = getRequestUrl(arguments[0]);

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartMutationUrl(requestUrl)) {
          scheduleUpdate(300);
          scheduleUpdate(900);
        }

        return response;
      });
    };
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.__cartPromoXhrPatched) {
      return;
    }

    window.__cartPromoXhrPatched = true;

    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__cartPromoUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (isCartMutationUrl(this.__cartPromoUrl)) {
        this.addEventListener('loadend', function () {
          scheduleUpdate(300);
          scheduleUpdate(900);
        });
      }

      return originalSend.apply(this, arguments);
    };
  }

  function init() {
    bindCartEvents();
    bindThemeEditorUpdates();
    bindDomUpdates();
    patchFetch();
    patchXhr();

    scheduleUpdate(0);
    scheduleUpdate(800);
  }

  window.updateCartPromoProgress = fetchAndUpdateCartPromoProgress;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();